import { CoreContext } from 'context/CoreContext';
import { useContext } from 'react';
import { Icon, ModalContainer, ModalContent, Overlay, Title } from 'ui/styled';
import { CloseContainer, CompanyDataContainer } from './styled';

export default function WrapperImport({ children }) {
  const { setModal } = useContext(CoreContext);
  const close = () => setModal(null);
  const handleClose = (e) => {
    const mc = document.getElementById('modal-content');
    // console.log("close", mc.contains(e?.target), e?.target)
    if (!mc?.contains(e?.target) && !(e?.target.tagName === 'LI')) {
      close();
    }
  };

  return (
    <Overlay onClick={handleClose}>
      <ModalContainer>
        <ModalContent id="modal-content">
          <CompanyDataContainer>
            <CloseContainer>
              <Title nomargin>Log de Importação</Title>
              <Icon icon={'close-big'} pointer={true} onClick={close} />
            </CloseContainer>
            {children}
          </CompanyDataContainer>
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
}
